import React, { createContext, useContext, useMemo, useState } from 'react';

type AnalyzeTabState = {
  analysisResult: string | null;
  setAnalysisResult: React.Dispatch<React.SetStateAction<string | null>>;
  hasAnalyzed: boolean;
  setHasAnalyzed: React.Dispatch<React.SetStateAction<boolean>>;
  isLoading: boolean;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  error: string | null;
  setError: React.Dispatch<React.SetStateAction<string | null>>;
};

// Default context which is only used when Context Provider is not provided, which should never happen
export const AnalyzeContext = createContext<AnalyzeTabState>({
  analysisResult: null,
  setAnalysisResult: () => undefined,
  hasAnalyzed: false,
  setHasAnalyzed: () => undefined,
  isLoading: false,
  setIsLoading: () => undefined,
  error: null,
  setError: () => undefined,
});

export const useAnalyzeContext = () => useContext(AnalyzeContext);

export interface AnalyzeContextProviderProps {
  children: React.ReactNode;
}

export const AnalyzeContextProvider = (props: AnalyzeContextProviderProps) => {
  const [analysisResult, setAnalysisResult] = useState<string | null>(null);
  const [hasAnalyzed, setHasAnalyzed] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const state = useMemo(
    () => ({
      analysisResult,
      setAnalysisResult,
      hasAnalyzed,
      setHasAnalyzed,
      isLoading,
      setIsLoading,
      error,
      setError,
    }),
    [analysisResult, hasAnalyzed, isLoading, error],
  );

  return <AnalyzeContext.Provider value={state}>{props.children}</AnalyzeContext.Provider>;
};
